import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface NOCMainProps {}

const NOCMain = (props: NOCMainProps) => {
  const routes = all_routes;

  const nocServices = [
    {
      title: "NOC for Outside Job",
      description: "Apply for No Objection Certificate for outside employment",
      route: routes.noc.outsideJob,
      icon: "ti ti-briefcase",
    },
    {
      title: "NOC for Passport / Visa",
      description: "Apply for No Objection Certificate for passport/visa applications",
      route: routes.noc.passport,
      icon: "ti ti-file-certificate",
    },
    {
      title: "NOC for Higher Education",
      description: "Apply for No Objection Certificate for higher education",
      route: routes.noc.higherEducation,
      icon: "ti ti-school",
    },
    {
      title: "NOC for Ex-India (Foreign Visit)",
      description: "Apply for No Objection Certificate for foreign visits",
      route: routes.noc.foreignVisit,
      icon: "ti ti-plane",
    },
    {
      title: "NOC/Reimbursement/Addition of Online Course",
      description: "Apply for online course NOC and reimbursement",
      route: routes.noc.onlineCourse,
      icon: "ti ti-device-laptop",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">No Objection Certificate (NOC)</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.employeeDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  NOC Services
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="row">
          {nocServices.map((service, index) => (
            <div key={index} className="col-lg-6 col-md-6 col-sm-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <div className="d-flex align-items-start mb-3">
                    <div className="avatar avatar-md bg-primary-transparent me-3">
                      <i className={`${service.icon} fs-20`}></i>
                    </div>
                    <div className="flex-fill">
                      <h5 className="card-title mb-2">{service.title}</h5>
                      <p className="text-muted mb-3">{service.description}</p>
                      <Link 
                        to={service.route} 
                        className="btn btn-primary btn-sm"
                      >
                        <i className="ti ti-arrow-right me-1"></i>
                        Access Service
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NOCMain;
